 import Vue from 'vue'
import Vuex from 'vuex'
 import store_loyalty from "@/views/loyalty/store_loyalty"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    snackbar: {
      text: '',
      show: false,
    },
    notif: {
      text: '',
      show: false,
      type: 0,
      count: 0,
    },
    header_notification: {
      show: false,
      text: '',
    },
    user: {
      id: '',
      surname: '',
      name: '',
      patronymic: '',
      phone: '',
      role: 0,
      rules: [],
      tab_client: 0,
      confirm: {},
    },
    clients: [],
    client: '',
    roles: {},
    dict: {
      role: {},
    },
    access: {},
    barColor: 'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
    drawer: null,
    pointId: '',
    skud_place: null,
  },
  mutations: {
    SET_FAVOURITE_TAB (state, data) {
      state.user[data.type] = data.value
    },
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    SET_NOTIF (state, data) {
      state.notif.text = data.text
      state.notif.type = data.type
      state.notif.show = true
    },
    SET_NOTIF_COUNT (state, data) {
      state.notif.count = data
    },
    HIDE_NOTIF (state) {
      state.notif.text = ''
      state.notif.type = 0
      state.notif.show = false
    },
    snackbar (state, data) {
      state.snackbar.text = data
      state.snackbar.show = true
    },
    user (state, user) {
      state.user.id = user.id
      state.user.phone = user.phone
      state.user.surname = user.surname
      state.user.name = user.name
      state.user.patronymic = user.patronymic
      state.user.role = user.role
      state.user.client = user.client
      state.user.rules = user.rules || []
      state.user.tab_client = user.tab_client
      state.user.confirm = user.confirm || {}
      state.user.roles = user.roles || []
      state.user.email = user.email
      state.user.current_client = user.current_client
      state.user.client_headers = user.client_headers || []
      state.user.device_headers = user.device_headers || []
      state.user.equipment_headers = user.equipment_headers || []
      state.user.item_headers = user.item_headers || []
      state.user.operator_headers = user.operator_headers || []
      state.user.place_headers = user.place_headers || []
      state.user.point_headers = user.point_headers || []
      state.user.recipient_headers = user.recipient_headers || []
      state.user.payment_headers = user.payment_headers || []
      state.user.order_headers = user.order_headers || []
      state.user.fiscal_headers = user.fiscal_headers || []
      state.user.member_headers = user.member_headers || []
      state.user.configuration_headers = user.configuration_headers || []
      state.user.nomenclature_headers = user.nomenclature_headers || []
      state.user.category_headers = user.category_headers || []
      state.user.sbp_headers = user.sbp_headers || []
      state.user.finalRecon_headers = user.finalRecon_headers || []
      state.user.pointTaskHeaders = user.pointTaskHeaders || []
      state.user.revenueHeaders = user.revenueHeaders || []
      state.user.productMovementHeaders = user.productMovementHeaders || []
      state.user.inventoryHeaders = user.inventoryHeaders || []
      state.user.profileHeaders = user.profileHeaders || []
      state.user.skud_passage_headers = user.skud_passage_headers || []
      state.user.skud_card_headers = user.skud_card_headers || []
      state.user.skud_visit_headers = user.skud_visit_headers || []
      state.user.skud_guest_headers = user.skud_guest_headers || []
      state.user.skud_audit_headers = user.skud_audit_headers || []
      state.user.skud_token_headers = user.skud_token_headers || []
    },
    dictionary (state, dict) {
      state.dict = dict
    },
    access (state, access) {
      state.access = access
    },
    roles (state, roles) {
      state.roles = roles
    },
    client (state, client) {
      state.client = client
    },
    clients (state, clients) {
      state.clients = clients
    },
    skud_place (state, v) {
      state.skud_place = v
    },
  },
  actions: {

  },
  modules: { ...store_loyalty } // for loyalty
})
